import { useMemo } from "react";

import { useSupabaseSession } from "~/context/SupabaseSessionContext";

export const useAnonymous = () => {
    const { loading, session } = useSupabaseSession();

    const isAnonymous = useMemo(() => !session?.user?.email, [session]);

    return { isAnonymous, isLoading: loading };
};
